  var custom_slider = new Swiper('.custom_slider', {
    slidesPerView: 4,
    centeredSlides: true,
    spaceBetween: 0,
    slidesPerGroup: 1,
    loop: true,
    loopFillGroupWithBlank: false,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      720: {
        slidesPerView: 6.75,
        spaceBetween: 50,
        loop: true,
      },
    },
  });